<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<div class="driver-view">
  <div>
    <div class="heading">
      <h3>Add Credit Trip</h3>
    </div>
    <mat-divider></mat-divider>
    <form class="admin-forms truckComponent mt-3" [formGroup]="addCreditForm">
      <div class="input-fileds-container category-edit">
        <div class="row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-4">
                <mat-form-field
                  class="flex-gt-sm example-full-width truck-type-input"
                >
                  <mat-select
                    dropLocationSearchField
                    formControlName="truck_id"
                    placeholder="Vehicle Number"
                    (selectionChange)="getDriverList($event)"
                    required
                  >
                    <mat-option
                      *ngFor="let item of vehicleArray"
                      value="{{ item._id }}"
                    >
                      {{ item.truck_number }}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please Select Vehicle number</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Driver Name</mat-label>
                  <input matInput formControlName="driver_id" readonly />
                  <mat-error>Please enter driver name</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Mobile Number</mat-label>
                  <input matInput formControlName="mobile" readonly />
                  <mat-error>Please enter mobile number</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Trip Booking Date</mat-label>
                  <mat-datepicker #picker1></mat-datepicker>
                  <input
                    matInput
                    [matDatepicker]="picker1"
                    placeholder="RC Valid"
                    [min]="minDate"
                    formControlName="tripbooking_date"
                    (click)="picker1.open()"
                    required
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker1"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>DO Quantity</mat-label>
                  <input matInput formControlName="workorder_qty" readonly />
                  <mat-error>Please Enter work order quantity</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Remaining Tons</mat-label>
                  <input matInput formControlName="remaining_tons" readonly />
                  <mat-error>Please Enter Remaining ton</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Net Quantity(Loading Point)</mat-label>
                  <input
                    matInput
                    appThreeDigitDecimalNumber
                    formControlName="loading_point"
                    (focusout)="remainingQnty($event)"
                    required
                  />
                  <mat-error>Please Enter Loading point</mat-error>
                  <mat-error></mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Net Quantity(Unloading Point)</mat-label>
                  <input
                    matInput
                    appThreeDigitDecimalNumber
                    (input)="validateUnloadingPoint()"
                    formControlName="unloading_point"
                  />
                  <mat-error>Please Enter Unloading point</mat-error>
                </mat-form-field>
              </div>

              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Price Per Ton</mat-label>
                  <input matInput formControlName="price_per_ton" readonly />
                  <mat-error>Please Enter Price per ton</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Sales Order Number</mat-label>
                  <input
                    matInput
                    formControlName="sales_order_number"
                    placeholder="Enter Sales order Number"
                    readonly
                    appAlphanumericOnly
                    toUppercase
                    maxlength="16"
                  />
                  <mat-error>Please Enter Sales order Number</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>LR No</mat-label>
                  <input
                    matInput
                    formControlName="lr_number"
                    placeholder="Enter LR Number"
                    required
                    appAlphanumericOnly
                    toUppercase
                    maxlength="16"
                  />
                  <mat-error>Please Enter LR Number</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>LR Date</mat-label>
                  <mat-datepicker #picker></mat-datepicker>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    placeholder="RC Valid"
                    [max]="maxDate"
                    required
                    formControlName="lr_date"
                    (click)="picker.open()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error>Select LR Date</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>Tax Invoice no</mat-label>
                  <input
                    matInput
                    formControlName="tax_invoice_no"
                    placeholder="Enter Tax Invoice Number"
                    required
                    toUppercase
                    maxlength="16"
                    (keypress)="validateTaxInvoiceInput($event)"
                  />
                  <mat-error>Please Enter Tax Invoice Number</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label>DDC No</mat-label>
                  <input
                    matInput
                    formControlName="ddc_no"
                    placeholder="Enter DDC Number"
                    required
                    appAlphanumericOnly
                    toUppercase
                    maxlength="16"
                  />
                  <mat-error>Please Enter DDC Number</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button
            type="button"
            [class.spinner]="loading"
            [disabled]="loading"
            class="button buttonBlue mt-3"
            (click)="addTrip()"
          >
            Add Trip
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
